import esDashboard from './dashboard/dashboard.json'
import esStats from './stats/stats.json'
import esAccreditation from './accreditation/accreditation.json'
import esCms from './cms/cms.json'
import esAuth from './auth/auth.json'
import esCommon from './common/common.json'
import esCompetition from './competition/competition.json'
import esGeneralApplications from './general-applications/general-applications.json'
import enLeague from './league/league.json'
import esMatch from './match/match.json'
import esNotification from './notification/notification.json'
import esOrganization from './organization/organization.json'
import esPhase from './phase/phase.json'
import esRecreation from './recreation/recreation.json'
import esRoles from './roles/roles.json'
import esSeason from './season/season.json'
import esShared from './shared/shared.json'
import esSponsor from './sponsor/sponsor.json'
import esSport from './sport/sport.json'
import esUnit from './unit/unit.json'
import esUser from './user/user.json'
import esUtils from './utils/utils.json'

export const es = {
    dashboard: esDashboard,
    stats: esStats,
    common: esCommon,
    accreditation: esAccreditation,
    notification: esNotification,
    league: enLeague,
    roles: esRoles,
    season: esSeason,
    sponsor: esSponsor,
    unit: esUnit,
    sport: esSport,
    user: esUser,
    organization: esOrganization,
    shared: esShared,
    competition: esCompetition,
    'general-applications': esGeneralApplications,
    utils: esUtils,
    phase: esPhase,
    auth: esAuth,
    match: esMatch,
    recreation: esRecreation,
    cms: esCms,
}
